module.exports = __webpack_public_path__ + "static/media/budget.24268bc6.svg";